export enum MACHINERY {
  SPRAYER = "SPRAYER",
  MOWER = "MOWER",
  SEED_BROADCASTER = "SEED_BROADCASTER",
  DIRECT_DRILL = "DIRECT_DRILL",
  MANURE_SPREADER = "MANURE_SPREADER",
  SLURRY_SPREADER = "SLURRY_SPREADER",
  BALER = "BALER",
}
export enum ARABLE_TYPE {
  WHEAT = "WHEAT",
  BARLEY = "BARLEY",
  OILSEED_RAPE = "OILSEED_RAPE",
  POTATO = "POTATO",
  MAIZ = "MAIZ",
  CEREALS = "CEREALS",
  VEGETABLES_SALAD = "VEGETABLES_SALAD",
  OTHERS = "OTHERS",
}

export enum FIELD_TYPE {
  GRASS = "GRASS",
  ARABLE = "ARABLE",
}

/**
 * Whether the user entered an applied amount as an absolute total or as a
 * per-hectare application rate. The canonical stored value is always the
 * absolute total; this flag records what the user typed so edit forms can
 * reopen in the same mode (the rate is re-derived from the field area).
 */
export enum AMOUNT_INPUT_MODE {
  TOTAL = "TOTAL",
  RATE = "RATE",
}

export enum YIELD_TYPES {
  GRASS = "GRASS",
  MILK = "MILK",
  MEAT = "MEAT",
  CROP = "CROP",
}
export enum GRASS_YIELD_TYPES {
  HAY = "HAY",
  SILAGE = "SILAGE",
  HAYLAGE = "HAYLAGE",
}

enum CROP_BY_PRODUCT {
  STRAW = "STRAW",
}

// Conserved forage harvested off an arable crop (as opposed to the grain).
// e.g. forage maize is harvested as maize silage, cereals as wholecrop silage.
export enum CROP_FORAGE {
  MAIZE_SILAGE = "MAIZE_SILAGE",
  WHOLECROP_SILAGE = "WHOLECROP_SILAGE",
}

export const CROP_YIELD_TYPE = {
  ...CROP_BY_PRODUCT,
  ...CROP_FORAGE,
  ...ARABLE_TYPE,
};

export type CROP_YIELD_TYPE = CROP_BY_PRODUCT | CROP_FORAGE | ARABLE_TYPE;
